module.exports = function (loginService) {
    return {
        restrict: 'E',
        template: require('./login-header-template.html').trim(),
        link(scope) {
            scope.cancel = function () {
                loginService.cancelLoginAndRedirect();
            };
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/login-header-directive.js
 **/